import { IS_PRODUCTION } from './constants'

const isCypress = Boolean(typeof window !== 'undefined' && window.Cypress)

/**
 * CSP Header notes:
 * For safe apps we have to allow img-src * and frame-src *
 * connect-src * because the RPCs are configurable (config service)
 * style-src unsafe-inline for our styled components
 * script-src unsafe-eval is needed by next.js in dev mode, otherwise only self
 * frame-ancestors can not be set via meta tag
 *
 * Fonts URLs are needed for WalletConnect
 * HubSpot and Calendly domains are needed for form and scheduling integrations
 */
export const ContentSecurityPolicy = `
 default-src 'self';
 connect-src 'self' *;
 script-src 'self' 'unsafe-inline' https://*.getbeamer.com https://www.googletagmanager.com https://*.ingest.sentry.io https://sentry.io https://*.hsforms.com https://*.hsforms.net https://*.hubspot.com https://js.hsadspixel.net https://*.hs-scripts.com https://*.usemessages.com https://assets.calendly.com ${
   !IS_PRODUCTION || isCypress
     ? "'unsafe-eval'" // Dev server and cypress need unsafe-eval
     : "'wasm-unsafe-eval'"
 };
 frame-src http: https:;
 style-src 'self' 'unsafe-inline' https://*.getbeamer.com https://*.googleapis.com https://*.hsforms.com https://assets.calendly.com;
 font-src 'self' data: https://fonts.gstatic.com https://fonts.reown.com;
 worker-src 'self' blob:;
 img-src * data:;
`
  .replace(/\s{2,}/g, ' ')
  .trim()

export const StrictTransportSecurity = 'max-age=31536000; includeSubDomains'
